import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _setPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/setPrototypeOf";

function _wrapRegExp() { _wrapRegExp = function _wrapRegExp(re, groups) { return new BabelRegExp(re, undefined, groups); }; var _super = RegExp.prototype; var _groups = new WeakMap(); function BabelRegExp(re, flags, groups) { var _this = new RegExp(re, flags); _groups.set(_this, groups || _groups.get(re)); return _setPrototypeOf(_this, BabelRegExp.prototype); } _inherits(BabelRegExp, RegExp); BabelRegExp.prototype.exec = function (str) { var result = _super.exec.call(this, str); if (result) result.groups = buildGroups(result, this); return result; }; BabelRegExp.prototype[Symbol.replace] = function (str, substitution) { if (typeof substitution === "string") { var groups = _groups.get(this); return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) { return "$" + groups[name]; })); } else if (typeof substitution === "function") { var _this = this; return _super[Symbol.replace].call(this, str, function () { var args = arguments; if (typeof args[args.length - 1] !== "object") { args = [].slice.call(args); args.push(buildGroups(args, _this)); } return substitution.apply(this, args); }); } else { return _super[Symbol.replace].call(this, str, substitution); } }; function buildGroups(result, re) { var g = _groups.get(re); return Object.keys(g).reduce(function (groups, name) { groups[name] = result[g[name]]; return groups; }, Object.create(null)); } return _wrapRegExp.apply(this, arguments); }

export function checkWebPSupport() {
  // Use canvas hack for webkit-based browsers
  // Kudos to Rui Marques: https://stackoverflow.com/a/27232658/7897049
  var e = document.createElement('canvas');

  if (e.toDataURL && e.toDataURL('image/webp').indexOf('data:image/webp') == 0) {
    return true;
  } // Check other common browsers by version


  var m = navigator.userAgent.match(/(Edg|Firefox)\/(\d+)\./);

  if (m) {
    return m[1] === 'Firefox' && m[2] >= 65 || m[1] === 'Edge' && m[2] >= 18;
  }

  m = navigator.userAgent.match( /*#__PURE__*/_wrapRegExp(/OS X[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]?([0-9]+)?.+ Version\/([0-9]+\.[0-9]+)/, {
    os: 1,
    v: 2
  }));

  if (m) {
    return m.groups.v >= 14 && (m.groups.os || 99) >= 11;
  }

  return false;
}